import type { RefObject } from 'react';

interface IFlashListScrollRef {
  scrollToEnd?: (options: { animated?: boolean }) => void;
}

interface IEnsureFlashListScrollToEndOptions {
  /** @default true */
  animated?: boolean;
}

/**
 * Scrolls a FlashList to the end after layout has caught up with new items.
 * Defer via timeout + rAF so scroll runs after refetch/remount updates (mobile web included).
 */
export function ensureFlashListScrollToEnd(
  listRef: RefObject<IFlashListScrollRef | null>,
  options: IEnsureFlashListScrollToEndOptions = {}
) {
  const { animated = true } = options;

  setTimeout(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        listRef.current?.scrollToEnd?.({ animated });
      });
    });
  }, 0);
}
